import React from "react";
import ArrowCircleRight from "../../../assets/ArrowCircleRight.svg";

export const AssessmentArtical = ({ icon, title, subtitle, imgSrc }) => {
  return (
    <div className="blog-post-card1">
      <img className="assessment-img" src={imgSrc} alt="Assessment" />
      <div className="content-ass">
        <div className="heading-and-subheading">
          <div className="heading-and-text">
            <div className="blog-content-post">
              <div className="heading-icon">
                <p className="heading-text">
                  {icon} {title}
                </p>
                <div className="icon-wrap"></div>
              </div>
              <p className="heading-subtitle">{subtitle}</p>
            </div>
          </div>
        </div>
      </div>
      <button className="btn-start-refection">
        <span className="btn-text">Start Reflection</span>
        <img className="arrow" src={ArrowCircleRight} alt="Arrow" />
      </button>
    </div>
  );
};
